/**
 * Human-readable age of a cached registration-status snapshot for field diagnostics.
 * Returns null when `savedAtMs` is missing or in the future.
 */
export function formatRegistrationSnapshotAge(savedAtMs: number | null | undefined, nowMs: number = Date.now()): string | null {
  if (savedAtMs == null || !Number.isFinite(savedAtMs) || savedAtMs <= 0) {
    return null
  }
  const ageMs = nowMs - savedAtMs
  if (ageMs < 0) {
    return null
  }
  const sec = Math.floor(ageMs / 1000)
  if (sec < 60) {
    return `${sec}s`
  }
  const min = Math.floor(sec / 60)
  if (min < 60) {
    return `${min}m`
  }
  const hr = Math.floor(min / 60)
  if (hr < 48) {
    return `${hr}h`
  }
  const days = Math.floor(hr / 24)
  return `${days}d`
}
